import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";

type Props = {
  src: string;
};

export const OptiversalESIUI = ({ src }: Props) => (
  <div data-component="OptiversalESI" data-testid="TestOptiversalESI">
    <ESIInclude id="OptiversalESI" src={src}></ESIInclude>
  </div>
);
